import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconSearchStyle0 = gravityIconIndividualCss;

const GravityIconSearch = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'fdbd2aae3af1864cc06519e6c167e8e34b982c2a', color: this.color, size: this.size }, h("svg", { key: '7c8ee4b96d0186f95f103d0f9050ddca6ab466d6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '8b6bd006445757e417ee0f99daf0c60769855c32', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.881 3A5.88 5.88 0 0 0 3 8.878a5.88 5.88 0 0 0 5.881 5.878 5.88 5.88 0 0 0 5.882-5.878A5.88 5.88 0 0 0 8.88 3Zm0 1.47a4.41 4.41 0 1 1 0 8.817 4.41 4.41 0 0 1-4.41-4.409A4.42 4.42 0 0 1 8.88 4.47Z", fill: "currentColor" }), h("path", { key: '87ec4960f2ec0707b863767599e5b7279c150efe', d: "M14.598 14.929a.5.5 0 0 0 0 .706l3.216 3.214a.5.5 0 0 0 .707 0l.333-.332a.5.5 0 0 0 0-.707l-3.216-3.214a.5.5 0 0 0-.707 0l-.333.332Z", fill: "currentColor" }))));
    }
};
GravityIconSearch.style = GravityIconSearchStyle0;

export { GravityIconSearch as gravity_icon_search };

//# sourceMappingURL=gravity-icon-search.entry.js.map